module.exports = __webpack_public_path__ + "static/media/portfolio-img5.30e07b0a.jpg";